module.exports = __webpack_public_path__ + "img/zxbg1.686fc43c.png";